import { useState, useCallback } from 'react';
import { investmentsImportExportApi } from '../services/investmentsImportExportApi';
import { StockImportResultDto } from '../types/stocks';

export const useInvestmentsImportExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadTemplate = useCallback(async (): Promise<Blob | null> => {
    setLoading(true);
    setError(null);
    try {
      return await investmentsImportExportApi.downloadTemplate();
    } catch (err: any) {
      setError(err.message || 'Não foi possível descarregar o modelo');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const exportAll = useCallback(async (): Promise<Blob | null> => {
    setLoading(true);
    setError(null);
    try {
      return await investmentsImportExportApi.exportAll();
    } catch (err: any) {
      setError(err.message || 'Não foi possível exportar os investimentos');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const importAll = useCallback(async (file: File, clearExisting: boolean): Promise<StockImportResultDto | null> => {
    setLoading(true);
    setError(null);
    try {
      return await investmentsImportExportApi.importAll(file, clearExisting);
    } catch (err: any) {
      setError(err.message || 'Não foi possível importar os investimentos');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadFile = useCallback((blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, []);

  return {
    loading,
    error,
    exportAll,
    importAll,
    downloadTemplate,
    downloadFile,
    clearError: () => setError(null),
  };
};
